export enum DestinationSelectSetting {
  none = 0,
  destinationOnly = 1,
  customAddressOnly = 2,
  both = 3
}

export class DestinationSelectSettingUtil {
  static label(setting: DestinationSelectSetting | null): string {
    if (setting === null) {
      return '';
    }

    switch (setting) {
      case DestinationSelectSetting.none:
        return '';
      case DestinationSelectSetting.destinationOnly:
        return 'Select a destination to get started';
      case DestinationSelectSetting.customAddressOnly:
        return 'Enter an address to get started';
      case DestinationSelectSetting.both:
        return 'Select a destination or enter an address to get started';
      default:
        return '';
    }
  }

  static placeholder(setting: DestinationSelectSetting | null): string {
    if (setting === null) {
      return '';
    }

    switch (setting) {
      case DestinationSelectSetting.none:
        return 'On-line ordering is temporary unavailable';
      case DestinationSelectSetting.destinationOnly:
        return 'Select a destination';
      case DestinationSelectSetting.customAddressOnly:
        return 'Enter an address';
      case DestinationSelectSetting.both:
        return 'Select a destination or enter an address to get started';
      default:
        return '';
    }
  }

  static getDestinationSelectSetting(args: { destinationSearch: boolean; delivery: boolean }): DestinationSelectSetting {
    const { destinationSearch, delivery } = args;
    if (destinationSearch && delivery) {
      return DestinationSelectSetting.both;
    } else if (destinationSearch) {
      return DestinationSelectSetting.destinationOnly;
    } else if (delivery) {
      return DestinationSelectSetting.customAddressOnly;
    } else {
      return DestinationSelectSetting.none;
    }
  }
}
